/**
 * Created by methee on 9/12/17.
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import cx from 'classnames';

import s from './NearbyMenus.css';

const messages = defineMessages({
  food: {
    id: 'hotel.nearby_food',
    defaultMessage: '##Food##',
    description: 'Nearby food',
  },
  attraction: {
    id: 'hotel.nearby_attractions',
    defaultMessage: '##Attractions##',
    description: 'Nearby attractions',
  },
  nightlife: {
    id: 'hotel.nearby_nightlife',
    defaultMessage: '##Nightlife##',
    description: 'Nearby nightlife',
  },
  running: {
    id: 'hotel.nearby_running',
    defaultMessage: '##Running##',
    description: 'Nearby running',
  },
});

const categories = ['food', 'attraction', 'nightlife'];

class NearbyMenus extends React.Component {
  static propTypes = {
    onSelectedMenu: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      category: 'food',
    };
  }

  onClick = category => {
    this.setState({ category });
    this.props.onSelectedMenu(category);
  };

  render() {
    const { category } = this.state;
    const list = [];
    categories.forEach(cat => {
      const message = messages[cat];
      list.push(
        <li key={cat}>
          <button
            className={cx(category === cat && s.selected)}
            onClick={() => {
              this.onClick(cat);
            }}
          >
            <FormattedMessage {...message} />
          </button>
        </li>,
      );
    });
    return <ul className={s.root}>{list}</ul>;
  }
}

export default withStyles(s)(NearbyMenus);
